import React, { useEffect, useRef, useState } from "react";

const Header = ({ icons, links, sports }) => {
  const { logo, close, menu } = icons;
  const { home, navButtons, gradaInfo } = links;
  const [overlay, setOverlay] = useState(false);
  const rootRef = useRef(null);

  // La hamburguesa de la barra de escritorio vive en el ERB (_navbar_desktop);
  // desde aquí solo se le engancha el clic. Nada de document en el render (SSR).
  useEffect(() => {
    const button = rootRef.current?.closest("header")?.querySelector(".navbar-desktop__menu");
    if (!button) return undefined;

    const toggle = () => setOverlay((open) => !open);
    button.addEventListener("click", toggle);
    return () => button.removeEventListener("click", toggle);
  }, []);

  useEffect(() => {
    const header = rootRef.current?.closest("header");
    const button = header?.querySelector(".navbar-desktop__menu");
    if (button) button.setAttribute("aria-expanded", String(overlay));
    document.documentElement.classList.toggle("--menu-open", overlay);
    if (!overlay) return undefined;

    // Foco al primer control visible del drawer (la X en escritorio, la primera sección en móvil).
    const focusable = [header?.querySelector(".overlay__close"), ...(header?.querySelectorAll(".overlay a") || [])];
    focusable.find((el) => el && el.offsetParent !== null)?.focus({ preventScroll: true });

    const onKey = (event) => {
      if (event.key === "Escape") setOverlay(false);
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.documentElement.classList.remove("--menu-open");
    };
  }, [overlay]);

  return (
    <>
      <div className="navbar-mobile" ref={rootRef}>
        <a href={home} className="navbar__logo" onClick={() => setOverlay(false)}
        aria-label="Inicio">
          <span dangerouslySetInnerHTML={{ __html: logo }} />
        </a>
        <button
          aria-label="Menú de Navegación"
          className="navbar__dropdown"
          onClick={() => setOverlay(!overlay)}
          dangerouslySetInnerHTML={{ __html: overlay ? close : menu }}
        />
      </div>

      <nav
        className={`overlay ${overlay ? "--open" : ""}`}
        aria-label="Secciones"
        onClick={(event) => {
          if (event.target === event.currentTarget) setOverlay(false);
        }}
      >
        <div className="overlay__panel">
          <div className="overlay__head">
            <a href={home} className="overlay__brand" aria-label="Inicio" onClick={() => setOverlay(false)}>
              <span dangerouslySetInnerHTML={{ __html: logo }} />
            </a>
            <button
              type="button"
              className="overlay__close"
              aria-label="Cerrar menú"
              onClick={() => setOverlay(false)}
              dangerouslySetInnerHTML={{ __html: close }}
            />
          </div>
          <p className="overlay__label">Secciones</p>
          <div className="sports">
            {sports.map(({ url, name, icon }) => (
              <a
                className="sports__item"
                href={url}
                key={name}
                onClick={() => setOverlay(false)}
              >
                {icon && (
                  <img
                    className="sports__item__icon"
                    src={icon}
                    alt=""
                    width="28"
                    height="28"
                    loading="lazy"
                  />
                )}
                <span>{name}</span>
              </a>
            ))}
          </div>
          <p className="overlay__label">Más de GRADA</p>
          <div className="grada-navigation">
            {[...navButtons.map((btn) => ({ name: btn["name"], url: btn["web_page"] })), ...gradaInfo].map(({ name, url }) => (
              <a
                className="grada-navigation__item"
                href={url}
                key={name}
                onClick={() => setOverlay(false)}
              >
                {name}
              </a>
            ))}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
